import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GradientComponent } from '@modules/shared/gradient/gradient.component';

@Component({
  templateUrl: './home-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GradientComponent, RouterOutlet],
  host: {
    class: 'relative flex flex-col',
  },
})
export class HomeLayoutComponent {}
